import React from "react";
import { buildTierView } from "../lib/tierCardCopy";
import useTodayKey from "./useTodayKey";
import useWakeAt from "./useWakeAt";

// 등급 뷰모델을 만드는 한 곳 — 날짜가 바뀌면(자정) · 뷰가 알려 준 시각(refreshAt — 자동 종료 안내가 닫히는 때)이 지나면 다시 만든다.
// 화면마다 useTodayKey·useWakeAt 을 따로 붙이면 빠뜨린다(137차 #1~#3 — 다섯 곳 중 한 곳만 refreshAt 을 봤다)
export default function useTierView(summary) {
  const todayKey = useTodayKey(Boolean(summary));   // 요약이 없으면 자정 감시를 걸지 않는다(140차 #2)
  const [wakeTick, setWakeTick] = React.useState(0);
  const view = React.useMemo(() => (summary ? buildTierView(summary) : null),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [summary, todayKey, wakeTick]);
  useWakeAt(view ? view.refreshAt : null, () => setWakeTick((t) => t + 1));
  return view;
}
